<template>
  <div>
    <dropdown :items="items" min-width="120px" close-on-click>
      <div v-ripple class="user-initials white primary--text">
        {{ initials }}
      </div>
      <template #item="{ item }">
        <dropdown-item @click="handleClick(item)" :icon="item.icon">
          <span>{{ item.text }}</span>
        </dropdown-item>
      </template>
    </dropdown>
    <Profile :open="profileOpen" @close="profileOpen = $event" />
  </div>
</template>

<script>
import Dropdown from "@/components/Dropdown/Dropdown.vue";
import DropdownItem from "./DropdownItem.vue";
import Profile from "./Profile";
import { logout } from "@/models/lib";
import { mapGetters } from "vuex";

export default {
  components: {
    Dropdown,
    DropdownItem,
    Profile
  },
  data: () => ({
    profileOpen: false,
    items: [
      { id: 0, icon: "account_box", text: "Perfil" },
      { id: 1, icon: "logout", text: "Logout" },
    ],
  }),
  computed: {
    ...mapGetters(["getUser"]),
    initials() {
      const user = this.getUser;
      return user ? user.getInitials() : "";
    },
  },
  methods: {
    handleClick(item) {
      const { id } = item;
      switch (id) {
        case 0:
          this.profileOpen = true
          break;
        case 1:
          logout();
          break;
        default:
          console.error("option not implemented");
          break;
      }
    },
  },
};
</script>

<style scoped>
.user-initials {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 0.25rem;
  user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
}
</style>